import { connect } from 'react-redux';
import { State } from 'widgets/redeem/root/root.reducers';
import RedemptionSuccess from './redemption-success.component';

const mapStateToProps = (state: State) => ({
    platform: state.redemption?.redeemData?.platform,
    platforms: state.redemptionV2.platforms,
    benefits: state.redemptionV2?.benefits ?? null
});

const RedemptionSuccessContainer = connect(mapStateToProps)(RedemptionSuccess);

export default RedemptionSuccessContainer;
